// BEFORE:
// <Route path="/prompts" element={<PromptListPage />} />
// <Route path="/prompts/new" element={<NewPromptPage />} />
// <Route path="/prompts/:promptId" element={<PromptDetailPage />} />

// AFTER:
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import PromptListPage      from './pages/PromptListPage';
import NewPromptPage       from './pages/NewPromptPage';
import PromptDetail    from './pages/PromptDetail';


export default function AppRoutes() {
  return (
    <Routes>
      {/* GET  /prompts */}
      <Route index               element={<PromptListPage />} />

      {/* GET  /prompts/new */}
      <Route path="new"          element={<NewPromptPage />} />

      {/* GET  /prompts/:promptId */}
    
      <Route path=":promptId" element={<PromptDetail />} />


      {/* Anything else under /prompts → back to /prompts */}
      <Route path="*"            element={<Navigate to="/prompts" replace />} />
    </Routes>
  );
}
